// ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = !!sessionStorage.getItem("userId"); // check login

  if (!isLoggedIn) {
    return <Navigate to="/Signin" replace />; // redirect to login
  }

  return children; // render the page if logged in
};

export default ProtectedRoute;
